import {
  ChangeDetectionStrategy, Component, inject, signal, OnInit,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ApiService } from '../../../core/services/api.service';
import { DataService } from '../../../core/services/data.service';
import { API_ROUTES } from '../../../core/constants/api-routes';

export interface DashboardStats {
  totalCampaigns: number;
  activeCampaigns: number;
  completedCampaigns: number;
}

export interface RecentActivity {
  id: string;
  title: string;
  description: string;
  date: string;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class Dashboard implements OnInit {
  private apiService = inject(ApiService);
  private dataService = inject(DataService);

  readonly profile = toSignal(this.dataService.profile$, { initialValue: null });
  readonly isLoading = signal(true);
  readonly stats = signal<DashboardStats | null>(null);
  readonly recentActivity = signal<RecentActivity[]>([]);

  readonly breadcrumbItems = [{ label: 'Dashboard' }];

  async ngOnInit(): Promise<void> {
    this.isLoading.set(true);
    await Promise.all([this.loadStats(), this.loadRecentActivity()]);
    this.isLoading.set(false);
  }

  private async loadStats(): Promise<void> {
    const resp = await this.apiService.request<DashboardStats>(
      'GET',
      API_ROUTES.GET_DASHBOARD_STATS,
      undefined,
      { showToaster: false }
    );
    if (resp.status && resp.data) this.stats.set(resp.data);
  }

  private async loadRecentActivity(): Promise<void> {
    const resp = await this.apiService.request<RecentActivity[]>(
      'GET',
      API_ROUTES.GET_RECENT_ACTIVITY,
      undefined,
      { showToaster: false }
    );
    if (resp.status && resp.data) this.recentActivity.set(resp.data);
  }
}
